// extracted by mini-css-extract-plugin
module.exports = {"marketLabel":"MyTrades_marketLabel__2ZbnF","tableHeadings":"MyTrades_tableHeadings__XacLr","tableItems":"MyTrades_tableItems__3kTE4"};